<template>
    <div class="fta-information-folder" style="padding-top: .4rem">

        <div class="folder">
            <van-row class="top-bg"></van-row>

            <van-row class="folder-cont">
                <van-row type="flex" class="query-area-hsCode">
                    <van-col :span="18">
                        <van-field v-model="keyword" placeholder="请输入检索信息" clearable/>
                    </van-col>
                    <van-col :span="6">
                        <van-button type="info" @click="handleSearchFileByQuery">查询</van-button>
                    </van-col>
                </van-row>
            </van-row>
        </div>

        <van-collapse v-model="activeFolderNames">
            <van-collapse-item v-for="(catalog,index) in folders" :key="index" :title="catalog.folder"
                               :name="catalog.folder">
                <van-row class="folder-list" v-for="(file,index) in catalog.files" :key="index">
                    <i class="folder-icon"></i>
                    <span class="folder-title" @click="handleReturnPdf(catalog.folder,file)">
            {{ file }}
          </span>
                </van-row>
            </van-collapse-item>
        </van-collapse>

    </div>
</template>

<script>
    import FtaInformationConst from '../dto/fta-information-const'
    import configManager from "@zhoujianhui/vip-core/src/manager/config-manager";

    export default {
        name: "FtaInformationCatalog",
        data() {
            return {
                keyword: "",
                activeFolderNames: [],
                folders: FtaInformationConst.FtaInformationFolder
            }
        },
        methods: {
            handleReturnPdf(folder, file) {
                const fullFileName = folder + "/" + file;
                window.EappApi.goThirdUrl(configManager.getConfig().pdfViewerUrl + "?file=https://zumoo-public.oss-cn-nanjing.aliyuncs.com/attachment/" + fullFileName);
            },
            handleSearchFileByQuery() {
                const filesResult = []
                if (!this.keyword) {
                    this.$toast("请输入检索信息");
                    return;
                }
                this.folders.forEach(catalog => {
                    const files = catalog.files.filter(file => file.indexOf(this.keyword) !== -1);
                    files.forEach(file => {
                        filesResult.push(catalog.folder + "/" + file);
                    })
                });
                if (filesResult.length === 0) {
                    this.$toast("未搜索到相应的文档");
                    return;
                }
                this.handleReturnFileResult(filesResult);
            },
            handleReturnFileResult(filesResult) {
                this.$router.push({
                    path: "/policy-query/fta-information-file",
                    query: {
                        fileResult: filesResult,
                        keyword: this.keyword
                    }
                });
            },
            toBankLink() {
                window.EappApi.goThirdUrl('http://m.cmbchina.com/Rate/FxRealrate.aspx#');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .fta-information-folder {
        .folder {
            height: auto;
            font-family: "Microsoft YaHei";
            display: flex;
            flex-direction: column;
            margin: 0;
            padding: 0;


            .top-bg {
                background: url("../images/mine-bg.png") no-repeat;
                width: 100%;
                height: 120px;
                background-size: 100% 100%;
            }

            .folder-cont {
                background-color: #ffffff;
                box-shadow: 0px 7px 82.32px 15.68px rgba(213, 213, 213, 0.35);
                margin: -88px auto 15px;
                width: 92%;
                padding: 31px 20px;
                box-sizing: border-box;
                display: flex;
            }

            .query-area-hsCode {
                width: 100%;
                height: .39rem;

                ::v-deep {
                    .van-cell {
                        padding: 7px 16px;
                        border: 1px solid #dcdfe6;
                    }

                    .van-button {
                        height: 40px;
                    }
                }


            }

        }

        .folder-list {
            display: flex;
            align-items: center;
            padding: 15px;
            box-sizing: border-box;

            .folder-icon {
                background: url("../images/folder.png") no-repeat;
                width: 28px;
                height: 34px;
                display: block;
                background-size: 100% 100%;
            }

            .bank-icon {
                background: url("../images/bank-icon.png") no-repeat;
                width: 28px;
                height: 27px;
                display: block;
                background-size: 100% 100%;
            }

            .folder-title {
                width: calc(100% - 43px);
                margin-left: 15px;
                font-size: 14px;
                color: #666666;
            }

            .link-title {
                /*color: #1890ff;
                text-decoration: underline;*/
            }

        }

        ::v-deep {
            .van-collapse {
                padding: 0 4%;

                .van-collapse-item {
                    margin-bottom: 15px;
                }

            }
        }

        .folder-footer {
            background: #ffffff;
            margin: 0 4%;

            .aboutBox {
                display: flex;
                align-items: center;
                flex-direction: column;
            }

            .aboutItem:first-child {
                margin-top: .2rem;
            }

            .aboutItem {
                display: flex;
                align-items: center;
                flex-direction: column;
                margin: .1rem 0;
            }

            .unitType {
                font-size: .13rem;
                color: #333333;
            }

            .unitName {
                font-size: .13rem;
                color: #333;
                font-weight: bold;
                margin-top: .1rem;
            }

            .unitName a {
                color: #333;
            }
        }
    }
</style>